export default class Input{
    static selectors = {
        main: '.b-input-text',
        input: '.b-input-text__input',
        counterUiMinus: '',
        counterUiPlus: '',
    };

    static init($context = $(document), options = {}) {
        $(Input.selectors.main, $context).each((i, elem) => {
            const $elem = $(elem);

            if( !$elem.hasClass('js-init') ) return;
            if( $elem.data('block-api') ) return;

            new Input($elem, options);
        })
    }

    constructor($elem, options) {
        this.params = $.extend({
            selectors: Input.selectors,
        }, options);

        this.elems = {
            $main: $elem,
            $input: $elem.find(this.params.selectors.input),
            counterUiMinus: $elem.find(this.params.selectors.counterUiMinus),
            counterUiPlus: $elem.find(this.params.selectors.counterUiPlus),
        };

        this.state = {
            defaultNumber: true
        }

        this.params.type = this.elems.$main.data('input-type');
        this.params.config = this.elems.$main.data('config') || {};

        this.startByInputType();

        this.initBlockApi();
    }

    initBlockApi() {
        this.elems.$main.data('block-api', this);
    }

    handleCounter() {
        const minValue = this.params.config.minValue || 0;
        const maxValue = this.params.config.maxValue || Infinity;

        this.elems.counterUiPlus.click(() => {
            const currentValue = +this.elems.$input.val();
            if( currentValue < maxValue ){
                this.elems.$input.val( currentValue + 1 );
            }
        });

        this.elems.counterUiMinus.click(() => {
            const currentValue = +this.elems.$input.val();
            if( currentValue > minValue ){
                this.elems.$input.val( currentValue - 1 );
            }
        });

        this.elems.$input.keydown((e) => {
            const approvedKeys = ['Backspace', 'Enter', 'ArrowLeft', 'ArrowRight', 'Delete'];
            const pattern = /[0-9]/;
            if(!pattern.test(e.key) && !approvedKeys.find( key => key === e.key )){
                e.preventDefault();
            } else if(pattern.test(e.key)){
                if(this.state.defaultNumber){
                    this.elems.$input.val(e.key);
                    this.state.defaultNumber = false;
                } else {
                    this.elems.$input.val(this.elems.$input.val() + e.key);
                }
                e.preventDefault();
            }
        })
    }

    handleDatepicker() {
        this.elems.$input.datepicker({
            autoClose: true
        });

        this.datepicker = this.elems.$input.datepicker().data('datepicker');

        this.elems.$input.click(() => {
            this.datepicker.show();
        })
    }

    startByInputType() {
        if (!this.params.type) return false;

        switch(this.params.type){
            case 'counter':
                this.handleCounter();
                break;
            case 'datepicker':
                this.handleDatepicker();
                break;
            default:
                break;
        }
    }
}
